import { createAction } from '@reduxjs/toolkit';
import { alertActions, cdvActions, patientActions, pnDueActions, dcDueActions, notesPendingActionActions } from '_actions';
import { noteService } from '_services';
import { ActionNames, Errors } from '_constants'
import { codeValidForAdmit } from '_helpers'
import { dashboardActions } from './dashboard.actions';

export const noteActions = {
    showAddendum: createAction(ActionNames.NOTE_SHOW_ADDENDUM),
    hideAddendum: createAction(ActionNames.NOTE_HIDE_ADDENDUM),

    showScribe: createAction(ActionNames.NOTE_SHOW_SCRIBE),
    hideScribe: createAction(ActionNames.NOTE_HIDE_SCRIBE),

    saveAddendum: (noteId, addendum) => (dispatch, getState) => {
        let ptno = getState().entities.cdv[noteId].ptno;
        dispatch(noteActions.saveAddendumRequest({ noteId }));

        noteService.saveAddendum(noteId, addendum)
            .then(
                () => {
                    dispatch(noteActions.saveAddendumSuccess(ptno));
                    dispatch(alertActions.successMsg('Addendum saved.'));
                }
                ,
                error => {
                    dispatch(noteActions.saveAddendumFailure({ noteId: noteId, error: error }));
                    dispatch(alertActions.error(Errors.NOTE_SAVE_ADDENDUM_FAILURE));
                }
            );
    },
    saveAddendumRequest: createAction(ActionNames.NOTE_SAVE_ADDENDUM_REQUEST),
    saveAddendumSuccess: createAction(ActionNames.NOTE_SAVE_ADDENDUM_SUCCESS),
    saveAddendumFailure: createAction(ActionNames.NOTE_SAVE_ADDENDUM_FAILURE),

    deleteNote: (noteId) => dispatch => {
        dispatch(noteActions.deleteNoteRequest({ noteId }));

        noteService.deleteNote(noteId)
            .then(
                () => {
                    dispatch(noteActions.deleteNoteSuccess(noteId));
                    dispatch(dashboardActions.loadOutstandingNotesQuiet());
                }
                ,
                error => {
                    dispatch(noteActions.deleteNoteFailure({ noteId: noteId, error: error }));
                    dispatch(alertActions.error(Errors.NOTE_DELETE_FAILURE));
                }
            );
    },
    deleteNoteRequest: createAction(ActionNames.NOTE_DELETE_REQUEST),
    deleteNoteSuccess: createAction(ActionNames.NOTE_DELETE_SUCCESS),
    deleteNoteFailure: createAction(ActionNames.NOTE_DELETE_FAILURE),

    reopenNote: (noteId, ptno) => dispatch => {
        dispatch(noteActions.reopenNoteRequest({ noteId }));

        noteService.reopenNote(noteId)
            .then(
                response => {
                    // based on response status, dispatch appropriate corresponding action
                    switch (response) {
                        case 1: // success
                            // get new note ID
                            dispatch(cdvActions.refreshCdv(ptno));
                            break;
                        case -2:
                        case -3: //not owner or manager
                            dispatch(alertActions.error(Errors.NOTE_REOPEN_OWNER));
                            break;
                        case -4: //notes got charges on a claim
                            dispatch(alertActions.error(Errors.NOTE_REOPEN_CLAIM));
                            break;
                        case -5: //note aint a sapphire one
                            dispatch(alertActions.error(Errors.NOTE_REOPEN_CWS));
                            break;
                        default:
                            break;
                    }
                }
                ,
                error => {
                    dispatch(alertActions.error(Errors.NOTE_START_FAILURE));
                }
            );
    },
    reopenNoteRequest: createAction(ActionNames.NOTE_DELETE_REQUEST),
    reopenNoteSuccess: createAction(ActionNames.NOTE_DELETE_SUCCESS),
    reopenNoteFailure: createAction(ActionNames.NOTE_DELETE_FAILURE),

    startNote: (epno, checkWarnings, aptid = undefined, adtdate = undefined, noteType = undefined) => (dispatch, getState) => {
        let ptno = getState().entities.admissions[epno].ptno;
        if (checkWarnings) {
            let warningsReturned = false;

            noteService.getStartNoteWarnings(epno)
                .then(
                    response => {
                        // based on response status, dispatch appropriate corresponding action
                        if (response[0].message !== '') {
                            let message = response[0].message;
                            // yes warnings
                            dispatch(noteActions.startNoteDisplayWarnings({ epno, message }));
                        } else {
                            // no warnings, start note
                            // display eval selection panel (transfer vs. prepopulate, etc.) 

                            if (getState().ui.admissions[epno].noteStarting) {
                                dispatch(alertActions.warning(Errors.NOTE_STARTING));
                            } else {

                                let thurno = null;


                                dispatch(noteActions.startNoteRequest({ epno }));
                                noteService.startNote(epno, aptid, adtdate, noteType)
                                    .then(
                                        response => {
                                            // based on response status, dispatch appropriate corresponding action
                                            switch (response.result.status) {
                                                case 1: // success
                                                    // get new note ID
                                                    dispatch(noteActions.startNoteSuccess({ epno, noteId: response.result.noteId }));
                                                    dispatch(noteActions.openInProgNote(response.result.noteId, ptno, epno));
                                                    dispatch(cdvActions.refreshCdv(ptno));
                                                    if (adtdate !== undefined) {
                                                        dispatch(dashboardActions.loadScheduleQuiet(new Date(adtdate)));
                                                    }
                                                    dispatch(dashboardActions.loadOutstandingNotesQuiet());
                                                    dispatch(patientActions.refreshAdmissions(ptno));
                                                    break;
                                                case 2: // eval options needed
                                                    // display eval selection panel (transfer vs. prepopulate, etc.) 
                                                    dispatch(noteActions.startNoteEvalOptions({ response, thurno }));
                                                    break;
                                                case 3: // in-progress warning
                                                case 4: // cets missing
                                                case 5: // cets missing AND in-progress warning
                                                case 6: // not full therapist and medicaid financial category
                                                case 7: // not full therapist or student or graduate
                                                    // display in-progress note warning
                                                    dispatch(noteActions.startNoteWarning({ epno: epno, status: response.result.status }));
                                                    break;
                                                case 8:
                                                    // display eval selection panel for transfer only 
                                                    dispatch(noteActions.startNoteEvalOptions({ response, thurno }));
                                                    break;
                                                case 9:
                                                    dispatch(noteActions.startNoteFailurePerm({ epno: epno }));
                                                    dispatch(alertActions.error(Errors.NOTE_START_FAILURE_PERM));
                                                    break;
                                                case 10:
                                                    dispatch(noteActions.startNoteFailureDisc({ epno: epno }));
                                                    dispatch(alertActions.error(Errors.NOTE_START_FAILURE_DISC));
                                                    break;
                                                default:
                                                    break;
                                            }
                                        }
                                        ,
                                        error => {
                                            dispatch(noteActions.startNoteFailure({ epno: epno, error: error }));
                                            dispatch(alertActions.error(Errors.NOTE_START_FAILURE));
                                        }
                                    );
                            }
                        }
                    }
                    ,
                    error => {
                        dispatch(noteActions.startNoteFailure({ epno: epno, error: error }));
                        dispatch(alertActions.error(Errors.NOTE_START_FAILURE));
                    }
                );
        } else {


            if (getState().ui.admissions[epno].noteStarting) {
                dispatch(alertActions.warning(Errors.NOTE_STARTING));
            } else {

                let thurno = null;

                dispatch(noteActions.startNoteRequest({ epno }));
                noteService.startNote(epno, aptid, adtdate, noteType)
                    .then(
                        response => {
                            // based on response status, dispatch appropriate corresponding action
                            switch (response.result.status) {
                                case 1: // success
                                    // get new note ID
                                    dispatch(noteActions.startNoteSuccess({ epno, noteId: response.result.noteId }));
                                    dispatch(noteActions.openInProgNote(response.result.noteId, ptno, epno));
                                    dispatch(cdvActions.refreshCdv(ptno));
                                    if (adtdate !== undefined) {
                                        dispatch(dashboardActions.loadScheduleQuiet(new Date(adtdate)));
                                    }
                                    dispatch(dashboardActions.loadOutstandingNotesQuiet());
                                    dispatch(patientActions.refreshAdmissions(ptno));
                                    break;
                                case 2: // eval options needed
                                    // display eval selection panel (transfer vs. prepopulate, etc.) 
                                    dispatch(noteActions.startNoteEvalOptions({ response, thurno }));
                                    break;
                                case 3: // in-progress warning
                                case 4: // cets missing
                                case 5: // cets missing AND in-progress warning
                                case 6: // not full therapist and medicaid financial category
                                case 7: // not full therapist or student or graduate
                                    // display in-progress note warning
                                    dispatch(noteActions.startNoteWarning({ epno: epno, status: response.result.status }));
                                    break;
                                case 8:
                                    // display eval selection panel for transfer only 
                                    dispatch(noteActions.startNoteEvalOptions({ response, thurno }));
                                    break;
                                case 9:
                                    dispatch(noteActions.startNoteFailurePerm({ epno: epno }));
                                    dispatch(alertActions.error(Errors.NOTE_START_FAILURE_PERM));
                                    break;
                                case 10:
                                    dispatch(noteActions.startNoteFailureDisc({ epno: epno }));
                                    dispatch(alertActions.error(Errors.NOTE_START_FAILURE_DISC));
                                    break;
                                default:
                                    break;
                            }
                        }
                        ,
                        error => {
                            dispatch(noteActions.startNoteFailure({ epno: epno, error: error }));
                            dispatch(alertActions.error(Errors.NOTE_START_FAILURE));
                        }
                    );

            }
        }
    },

    startNoteScribe: (epno, thurno, aptid = undefined, adtdate = undefined, noteType = undefined) => (dispatch, getState) => {
        if (getState().ui.admissions[epno].noteStarting) {
            dispatch(alertActions.warning(Errors.NOTE_STARTING));
        } else {
            let ptno = getState().entities.admissions[epno].ptno;

            dispatch(noteActions.startNoteRequest({ epno }));

            dispatch(patientActions.hideScribeOptions({ epno }))

            noteService.startNoteScribe(epno, thurno, aptid, adtdate, noteType)
                .then(
                    response => {
                        // based on response status, dispatch appropriate corresponding action
                        switch (response.result.status) {
                            case 1: // success
                                // get new note ID
                                dispatch(noteActions.startNoteSuccess({ epno, noteId: response.result.noteId }));
                                dispatch(noteActions.openInProgNote(response.result.noteId, ptno, epno));
                                dispatch(cdvActions.refreshCdv(ptno));
                                if (adtdate !== undefined) {
                                    dispatch(dashboardActions.loadScheduleQuiet(new Date(adtdate)));
                                }
                                dispatch(dashboardActions.loadOutstandingNotesQuiet());
                                dispatch(patientActions.refreshAdmissions(ptno));
                                break;
                            case 2: // eval options needed
                                // display eval selection panel (transfer vs. prepopulate, etc.)
                                dispatch(noteActions.startNoteEvalOptions({ response, thurno }));
                                break;
                            case 3: // in-progress warning
                            case 4: // cets missing
                            case 5: // cets missing AND in-progress warning
                            case 6: // not full therapist and medicaid financial category
                            case 7: // not full therapist or student or graduate
                                // display in-progress note warning
                                dispatch(noteActions.startNoteWarning({ epno: epno, status: response.result.status }));
                                break;
                            case 8:
                                let transferOnly = true;
                                // display eval selection panel for transfer only 
                                dispatch(noteActions.startNoteEvalOptions({ response, transferOnly }));
                                break;
                            case 9:
                                dispatch(noteActions.startNoteFailurePerm({ epno: epno }));
                                dispatch(alertActions.error(Errors.NOTE_START_FAILURE_PERM));
                                break;
                            case 10:
                                dispatch(noteActions.startNoteFailureDisc({ epno: epno }));
                                dispatch(alertActions.error(Errors.NOTE_START_FAILURE_DISC));
                                break;
                            default:
                                break;
                        }
                    }
                    ,
                    error => {
                        dispatch(noteActions.startNoteFailure({ epno: epno, error: error }));
                        dispatch(alertActions.error(Errors.NOTE_START_FAILURE));
                    }
                );
        }
    },
    startNoteDisplayWarnings: createAction(ActionNames.NOTE_START_WARNINGS),
    startNoteDisplayWarningsClear: createAction(ActionNames.NOTE_START_WARNINGS_CLEAR),
    startNoteRequest: createAction(ActionNames.NOTE_START_REQUEST),
    startNoteSuccess: createAction(ActionNames.NOTE_START_SUCCESS),
    startNoteFailure: createAction(ActionNames.NOTE_START_FAILURE),
    startNoteFailureDisc: createAction(ActionNames.NOTE_START_FAILURE_DISC),
    startNoteFailurePerm: createAction(ActionNames.NOTE_START_FAILURE_PERM),
    startNoteEvalOptions: createAction(ActionNames.NOTE_START_EVAL_OPTIONS),
    startNoteEvalOptionsPeds: createAction(ActionNames.NOTE_START_EVAL_OPTIONS_PEDS),
    startNoteEvalOptionsClear: createAction(ActionNames.NOTE_START_EVAL_OPTIONS_CLEAR),
    startNoteWarning: createAction(ActionNames.NOTE_START_WARNING),
    startNoteWarningClear: createAction(ActionNames.NOTE_START_WARNING_CLEAR),


    transferEval: (epno, noteId, aptid = undefined, adtdate = undefined, usePedsTemplate) => (dispatch, getState) => {
        if (getState().ui.admissions[epno].noteStarting) {
            dispatch(alertActions.warning(Errors.NOTE_STARTING));
        } else {
            let ptno = getState().entities.admissions[epno].ptno;
            dispatch(noteActions.transferEvalRequest({ epno, noteId }));

            console.log(usePedsTemplate);

            noteService.transferEval(epno, noteId, aptid, adtdate, usePedsTemplate)
                .then(
                    response => {
                        dispatch(noteActions.transferEvalSuccess({ epno: epno, noteId: response.noteId, ptno }));
                        dispatch(noteActions.startNote(epno));
                        dispatch(cdvActions.refreshCdv(ptno));
                        dispatch(patientActions.refreshAdmissions(ptno));
                    }
                    ,
                    error => {
                        dispatch(noteActions.transferEvalFailure({ epno: epno, error: error }));
                        dispatch(alertActions.error(Errors.EVAL_TRANSFER_FAILURE));
                    }
                );
        }
    },
    transferEvalScribe: (epno, noteId, aptid = undefined, adtdate = undefined, thurno, usePedsTemplate) => (dispatch, getState) => {
        if (getState().ui.admissions[epno].noteStarting) {
            dispatch(alertActions.warning(Errors.NOTE_STARTING));
        } else {
            let ptno = getState().entities.admissions[epno].ptno;
            dispatch(noteActions.transferEvalRequest({ epno, noteId }));

            noteService.transferEval(epno, noteId, aptid, adtdate, usePedsTemplate)
                .then(
                    response => {
                        dispatch(noteActions.transferEvalSuccess({ epno: epno, noteId: response.noteId, ptno }));
                        dispatch(noteActions.startNoteScribe(epno, thurno));
                        dispatch(cdvActions.refreshCdv(ptno));
                        dispatch(patientActions.refreshAdmissions(ptno));
                    }
                    ,
                    error => {
                        dispatch(noteActions.transferEvalFailure({ epno: epno, error: error }));
                        dispatch(alertActions.error(Errors.EVAL_TRANSFER_FAILURE));
                    }
                );
        }
    },
    transferEvalRequest: createAction(ActionNames.EVAL_TRANSFER_REQUEST),
    transferEvalSuccess: createAction(ActionNames.EVAL_TRANSFER_SUCCESS),
    transferEvalFailure: createAction(ActionNames.EVAL_TRANSFER_FAILURE),

    prepopulateEval: (epno, noteId, aptid = undefined, adtdate = undefined, usePedsTemplate) => (dispatch, getState) => {
        if (getState().ui.admissions[epno].noteStarting) {
            dispatch(alertActions.warning(Errors.NOTE_STARTING));
        } else {
            let ptno = getState().entities.admissions[epno].ptno;
            dispatch(noteActions.prepopulateEvalRequest({ epno, noteId }));

            noteService.prepopulateEval(epno, noteId, aptid, adtdate, usePedsTemplate)
                .then(
                    response => {
                        dispatch(noteActions.prepopulateEvalSuccess({ epno: epno, noteId: response.noteId, ptno }));
                        dispatch(noteActions.openInProgNote(response.noteId, ptno, epno));
                        dispatch(cdvActions.refreshCdv(ptno));
                        dispatch(patientActions.refreshAdmissions(ptno));
                    }
                    ,
                    error => {
                        dispatch(noteActions.prepopulateEvalFailure({ epno: epno, error: error }));
                        dispatch(alertActions.error(Errors.EVAL_PREPOPULATE_FAILURE));
                    }
                );
        }
    },
    prepopulateEvalScribe: (epno, noteId, aptid = undefined, adtdate = undefined, thurno, usePedsTemplate) => (dispatch, getState) => {
        if (getState().ui.admissions[epno].noteStarting) {
            dispatch(alertActions.warning(Errors.NOTE_STARTING));
        } else {
            let ptno = getState().entities.admissions[epno].ptno;
            dispatch(noteActions.prepopulateEvalRequest({ epno, noteId }));

            noteService.prepopulateEvalScribe(epno, noteId, aptid, adtdate, thurno, usePedsTemplate)
                .then(
                    response => {
                        dispatch(noteActions.prepopulateEvalSuccess({ epno: epno, noteId: response.noteId, ptno }));
                        dispatch(noteActions.openInProgNote(response.noteId, ptno, epno));
                        dispatch(cdvActions.refreshCdv(ptno));
                        dispatch(patientActions.refreshAdmissions(ptno));
                    }
                    ,
                    error => {
                        dispatch(noteActions.prepopulateEvalFailure({ epno: epno, error: error }));
                        dispatch(alertActions.error(Errors.EVAL_PREPOPULATE_FAILURE));
                    }
                );
        }
    },
    prepopulateEvalRequest: createAction(ActionNames.EVAL_PREPOPULATE_REQUEST),
    prepopulateEvalSuccess: createAction(ActionNames.EVAL_PREPOPULATE_SUCCESS),
    prepopulateEvalFailure: createAction(ActionNames.EVAL_PREPOPULATE_FAILURE),

    startBlankEval: (epno, aptid = undefined, adtdate = undefined, usePedsTemplate) => (dispatch, getState) => {
        if (getState().ui.admissions[epno].noteStarting) {
            dispatch(alertActions.warning(Errors.NOTE_STARTING));
        } else {
            let ptno = getState().entities.admissions[epno].ptno;
            dispatch(noteActions.startBlankEvalRequest({ epno, aptid, adtdate }));

            noteService.startBlankEval(epno, aptid, adtdate, usePedsTemplate)
                .then(
                    response => {
                        dispatch(noteActions.startBlankEvalSuccess({ epno: epno, noteId: response.noteId, ptno }));
                        dispatch(noteActions.openInProgNote(response.noteId, ptno, epno));
                        dispatch(cdvActions.refreshCdv(ptno));
                        dispatch(patientActions.refreshAdmissions(ptno));
                    }
                    ,
                    error => {
                        dispatch(noteActions.startBlankEvalFailure({ epno: epno, error: error }));
                        dispatch(alertActions.error(Errors.EVAL_START_BLANK_FAILURE));
                    }
                );
        }
    },
    startBlankEvalScribe: (epno, aptid = undefined, adtdate = undefined, thurno, usePedsTemplate) => (dispatch, getState) => {
        if (getState().ui.admissions[epno].noteStarting) {
            dispatch(alertActions.warning(Errors.NOTE_STARTING));
        } else {
            let ptno = getState().entities.admissions[epno].ptno;
            dispatch(noteActions.startBlankEvalRequest({ epno, aptid, adtdate, usePedsTemplate }));

            noteService.startBlankEvalScribe(epno, aptid, adtdate, thurno, usePedsTemplate)
                .then(
                    response => {
                        dispatch(noteActions.startBlankEvalSuccess({ epno: epno, noteId: response.noteId, ptno }));
                        dispatch(noteActions.openInProgNote(response.noteId, ptno, epno));
                        dispatch(cdvActions.refreshCdv(ptno));
                        dispatch(patientActions.refreshAdmissions(ptno));
                    }
                    ,
                    error => {
                        dispatch(noteActions.startBlankEvalFailure({ epno: epno, error: error }));
                        dispatch(alertActions.error(Errors.EVAL_START_BLANK_FAILURE));
                    }
                );
        }
    },
    startBlankEvalRequest: createAction(ActionNames.EVAL_START_BLANK_REQUEST),
    startBlankEvalSuccess: createAction(ActionNames.EVAL_START_BLANK_SUCCESS),
    startBlankEvalFailure: createAction(ActionNames.EVAL_START_BLANK_FAILURE),

    openInProgNote: (noteId, ptno, epno) => (dispatch, getState) => {
        dispatch(noteActions.openInProgNoteRequest({ noteId, ptno, epno }));
        let noteType = parseInt(noteId.split("_")[0]);
        let pk = parseInt(noteId.split("_")[1]);
        let fotoTypes = [13, 14, 15, 16, 17, 18, 19, 20, 21];
        let isWc = getState().entities.admissions[epno].isWc;

        if ((noteType === 1 && !getState().entities.notes.PTEVAL.hasOwnProperty(pk)) ||
            (noteType !== 1 && !getState().entities.notes.PTNOTE.hasOwnProperty(pk))) {
            dispatch(noteActions.loadInProgNoteRequest({ noteId, isWc }));
            noteService.load(noteId)
                .then(
                    noteData => {
                        dispatch(noteActions.loadInProgNoteSuccess({ noteId, noteData }));
                        dispatch(noteActions.openInProgNoteSuccess({ noteId }));
                        dispatch(patientActions.openAl(epno, ptno, false));
                        let fotos = Object.keys(getState().entities.cdv)
                            .filter(x => getState().entities.cdv[x].epno === epno && fotoTypes.includes(getState().entities.cdv[x].noteType))
                            .sort((a, b) => new Date(getState().entities.cdv[b].dos).getTime() - new Date(getState().entities.cdv[a].dos).getTime());
                        if (fotos.length > 0) {
                            dispatch(patientActions.openPdf(fotos[0], false));
                        }

                        //open pdf if needed
                        if (noteType != 1) {
                            if (getState().entities.dashboard.openEvalPdf) {
                                let evalID = getState().entities.notes.PTNOTE[pk].NTMNNO !== null ? "7_" + getState().entities.notes.PTNOTE[pk].NTMNNO : "1_" + getState().entities.notes.PTNOTE[pk].NTEVNO;
                                dispatch(patientActions.openPdf(evalID, false, 3));
                            }
                        }
                    },
                    error => {
                        dispatch(noteActions.loadInProgNoteFailure({ noteId: noteId, error: error }));
                        dispatch(noteActions.openInProgNoteFailure({ noteId: noteId, error: error }));
                        dispatch(alertActions.error(Errors.NOTE_IN_PROG_OPEN_FAILURE));
                    }
                );
            dispatch(patientActions.loadFotoEpisodes(ptno));
        } else {
            dispatch(noteActions.openInProgNoteSuccess({ noteId }));
            let epno = noteType === 1 ? getState().entities.notes.PTEVAL[pk].EVEPNO : getState().entities.notes.PTNOTE[pk].NTEPNO;
            dispatch(patientActions.openAl(epno, ptno, false));
            let fotos = Object.keys(getState().entities.cdv)
                .filter(x => getState().entities.cdv[x].epno === epno && fotoTypes.includes(getState().entities.cdv[x].noteType))
                .sort((a, b) => new Date(getState().entities.cdv[b].dos).getTime() - new Date(getState().entities.cdv[a].dos).getTime());
            if (fotos.length > 0) {
                dispatch(patientActions.openPdf(fotos[0], false));
            }
            dispatch(patientActions.loadFotoEpisodes(ptno));
        }
    },
    openInProgNoteRequest: createAction(ActionNames.NOTE_IN_PROG_OPEN_REQUEST),
    openInProgNoteSuccess: createAction(ActionNames.NOTE_IN_PROG_OPEN_SUCCESS),
    openInProgNoteFailure: createAction(ActionNames.NOTE_IN_PROG_OPEN_FAILURE),

    loadInProgNoteRequest: createAction(ActionNames.NOTE_IN_PROG_LOAD_REQUEST),
    loadInProgNoteSuccess: createAction(ActionNames.NOTE_IN_PROG_LOAD_SUCCESS),
    loadInProgNoteFailure: createAction(ActionNames.NOTE_IN_PROG_LOAD_FAILURE),

    toggleSectionVisibility: createAction(ActionNames.NOTE_TOGGLE_SECTION_VISIBILITY),

    updateTextField: (noteId, entity, entityKeyColumn, entityKeyValue, field, value) => (dispatch, getState) => {
        dispatch(noteActions.updateTextFieldRequest({ noteId, entity, entityKeyColumn, entityKeyValue, field, value }));

        noteService.updateTextField(noteId, entity, entityKeyColumn, entityKeyValue, field, value)
            .then(
                () => {
                    dispatch(noteActions.updateTextFieldSuccess({ noteId, entity, entityKeyColumn, entityKeyValue, field, value }));
                }
                ,
                error => {
                    dispatch(noteActions.updateTextFieldFailure({ noteId, entity, entityKeyColumn, entityKeyValue, field, value, error }));
                    dispatch(alertActions.error(Errors.NOTE_UPDATE_TEXT_FIELD_FAILURE));
                }
            );
    },
    updateTextFieldRequest: createAction(ActionNames.NOTE_UPDATE_TEXT_FIELD_REQUEST),
    updateTextFieldSuccess: createAction(ActionNames.NOTE_UPDATE_TEXT_FIELD_SUCCESS),
    updateTextFieldFailure: createAction(ActionNames.NOTE_UPDATE_TEXT_FIELD_FAILURE),

    updateBitField: (noteId, entity, entityKeyColumn, entityKeyValue, field, value) => (dispatch, getState) => {
        dispatch(noteActions.updateBitFieldRequest({ noteId, entity, entityKeyColumn, entityKeyValue, field, value }));

        noteService.updateBitField(noteId, entity, entityKeyColumn, entityKeyValue, field, value)
            .then(
                () => {
                    dispatch(noteActions.updateBitFieldSuccess({ noteId, entity, entityKeyColumn, entityKeyValue, field, value }));
                }
                ,
                error => {
                    dispatch(noteActions.updateBitFieldFailure({ noteId, entity, entityKeyColumn, entityKeyValue, field, value, error }));
                    dispatch(alertActions.error(Errors.NOTE_UPDATE_BIT_FIELD_FAILURE));
                }
            );
    },
    updateBitFieldRequest: createAction(ActionNames.NOTE_UPDATE_BIT_FIELD_REQUEST),
    updateBitFieldSuccess: createAction(ActionNames.NOTE_UPDATE_BIT_FIELD_SUCCESS),
    updateBitFieldFailure: createAction(ActionNames.NOTE_UPDATE_BIT_FIELD_FAILURE),

    updateALTime: (asTime, thTime, toTime, xlno, field, noteID) => (dispatch) => {
        dispatch(noteActions.updateALTimeRequest({ asTime, thTime, toTime, xlno, field, noteID }));

        noteService.updateALTime(asTime, thTime, toTime, xlno, field)
            .then(
                () => {
                    //success
                    dispatch(noteActions.updateALTimeSuccess({ asTime, thTime, toTime, xlno, field, noteID }));
                },
                error => {
                    dispatch(noteActions.updateALTimeFailure({ asTime, thTime, toTime, xlno, field, noteID, error }));
                    dispatch(alertActions.error(Errors.AL_UPDATE_TIME_FAILURE));
                }
            );
    },
    updateALTimeRequest: createAction(ActionNames.AL_UPDATE_TIME_REQUEST),
    updateALTimeSuccess: createAction(ActionNames.AL_UPDATE_TIME_SUCCESS),
    updateALTimeFailure: createAction(ActionNames.AL_UPDATE_TIME_FAILURE),

    updateIntField: (noteId, entity, entityKeyColumn, entityKeyValue, field, value) => (dispatch, getState) => {
        dispatch(noteActions.updateIntFieldRequest({ noteId, entity, entityKeyColumn, entityKeyValue, field, value }));
        noteService.updateIntField(noteId, entity, entityKeyColumn, entityKeyValue, field, value)
            .then(
                () => {
                    //this.props.updateIntField(this.props.noteId, 'MLEXLOG', 'XLNO', this.props.xlno, this.props.timeField + 'Assist', 0);
                    dispatch(noteActions.updateIntFieldSuccess({ noteId, entity, entityKeyColumn, entityKeyValue, field, value }));
                }
                ,
                error => {
                    dispatch(noteActions.updateIntFieldFailure({ noteId, entity, entityKeyColumn, entityKeyValue, field, value, error }));
                    dispatch(alertActions.error(Errors.NOTE_UPDATE_INT_FIELD_FAILURE));
                }
            );
    },
    updateIntFieldRequest: createAction(ActionNames.NOTE_UPDATE_INT_FIELD_REQUEST),
    updateIntFieldSuccess: createAction(ActionNames.NOTE_UPDATE_INT_FIELD_SUCCESS),
    updateIntFieldFailure: createAction(ActionNames.NOTE_UPDATE_INT_FIELD_FAILURE),


    updateDecimalField: (noteId, entity, entityKeyColumn, entityKeyValue, field, value) => (dispatch, getState) => {
        dispatch(noteActions.updateDecimalFieldRequest({ noteId, entity, entityKeyColumn, entityKeyValue, field, value }));

        noteService.updateDecimalField(noteId, entity, entityKeyColumn, entityKeyValue, field, value)
            .then(
                () => {
                    dispatch(noteActions.updateDecimalFieldSuccess({ noteId, entity, entityKeyColumn, entityKeyValue, field, value }));
                }
                ,
                error => {
                    dispatch(noteActions.updateDecimalFieldFailure({ noteId, entity, entityKeyColumn, entityKeyValue, field, value, error }));
                    dispatch(alertActions.error(Errors.NOTE_UPDATE_DECIMAL_FIELD_FAILURE));
                }
            );
    },
    updateDecimalFieldRequest: createAction(ActionNames.NOTE_UPDATE_DECIMAL_FIELD_REQUEST),
    updateDecimalFieldSuccess: createAction(ActionNames.NOTE_UPDATE_DECIMAL_FIELD_SUCCESS),
    updateDecimalFieldFailure: createAction(ActionNames.NOTE_UPDATE_DECIMAL_FIELD_FAILURE),


    clearField: (noteId, entity, entityKeyColumn, entityKeyValue, field) => (dispatch, getState) => {
        dispatch(noteActions.clearFieldRequest({ noteId, entity, entityKeyColumn, entityKeyValue, field }));

        noteService.clearField(noteId, entity, entityKeyColumn, entityKeyValue, field)
            .then(
                () => {
                    dispatch(noteActions.clearFieldSuccess({ noteId, entity, entityKeyColumn, entityKeyValue, field }));
                }
                ,
                error => {
                    dispatch(noteActions.clearFieldFailure({ noteId, entity, entityKeyColumn, entityKeyValue, field, error }));
                    dispatch(alertActions.error(Errors.NOTE_CLEAR_FIELD_FAILURE));
                }
            );
    },
    clearFieldRequest: createAction(ActionNames.NOTE_CLEAR_FIELD_REQUEST),
    clearFieldSuccess: createAction(ActionNames.NOTE_CLEAR_FIELD_SUCCESS),
    clearFieldFailure: createAction(ActionNames.NOTE_CLEAR_FIELD_FAILURE),


    clearFields: (noteId, entity, entityKeyColumn, entityKeyValue, fields) => (dispatch, getState) => {
        dispatch(noteActions.clearFieldsRequest({ noteId, entity, entityKeyColumn, entityKeyValue, fields }));

        noteService.clearFields(noteId, entity, entityKeyColumn, entityKeyValue, fields)
            .then(
                () => {
                    dispatch(noteActions.clearFieldsSuccess({ noteId, entity, entityKeyColumn, entityKeyValue, fields }));
                }
                ,
                error => {
                    dispatch(noteActions.clearFieldsFailure({ noteId, entity, entityKeyColumn, entityKeyValue, fields, error }));
                    dispatch(alertActions.error(Errors.NOTE_CLEAR_FIELDS_FAILURE));
                }
            );
    },
    clearFieldsRequest: createAction(ActionNames.NOTE_CLEAR_FIELDS_REQUEST),
    clearFieldsSuccess: createAction(ActionNames.NOTE_CLEAR_FIELDS_SUCCESS),
    clearFieldsFailure: createAction(ActionNames.NOTE_CLEAR_FIELDS_FAILURE),


    clearSpineFields: (noteId) => (dispatch, getState) => {
        dispatch(noteActions.clearSpineFieldsRequest({ noteId }));

        noteService.clearSpineFields(noteId)
            .then(
                () => {
                    let degreeKeys = getState().entities.masterData.PROPS['PTERO_SPINE_DEGREE_PANELS'].PRVALUE.split(',').map(Number);
                    let percentKeys = getState().entities.masterData.PROPS['PTERO_SPINE_PERCENT_PANELS'].PRVALUE.split(',').map(Number);

                    dispatch(noteActions.clearSpineFieldsSuccess({ noteId, degreeKeys, percentKeys }));
                }
                ,
                error => {
                    dispatch(noteActions.clearSpineFieldsFailure({ noteId, error }));
                    dispatch(alertActions.error(Errors.NOTE_CLEAR_SPINE_FIELDS_FAILURE));
                }
            );
    },
    clearSpineFieldsRequest: createAction(ActionNames.NOTE_CLEAR_SPINE_FIELDS_REQUEST),
    clearSpineFieldsSuccess: createAction(ActionNames.NOTE_CLEAR_SPINE_FIELDS_SUCCESS),
    clearSpineFieldsFailure: createAction(ActionNames.NOTE_CLEAR_SPINE_FIELDS_FAILURE),


    updateDateField: (noteId, entity, entityKeyColumn, entityKeyValue, field, value) => (dispatch, getState) => {
        dispatch(noteActions.updateDateFieldRequest({ noteId, entity, entityKeyColumn, entityKeyValue, field, value }));
        noteService.updateDateField(noteId, entity, entityKeyColumn, entityKeyValue, field, value)
            .then(
                () => {
                    dispatch(noteActions.updateDateFieldSuccess({ noteId, entity, entityKeyColumn, entityKeyValue, field, value }));
                }
                ,
                error => {
                    dispatch(noteActions.updateDateFieldFailure({ noteId, entity, entityKeyColumn, entityKeyValue, field, value, error }));
                    dispatch(alertActions.error(Errors.NOTE_UPDATE_DATE_FIELD_FAILURE));
                }
            );
    },
    updateDateFieldRequest: createAction(ActionNames.NOTE_UPDATE_DATE_FIELD_REQUEST),
    updateDateFieldSuccess: createAction(ActionNames.NOTE_UPDATE_DATE_FIELD_SUCCESS),
    updateDateFieldFailure: createAction(ActionNames.NOTE_UPDATE_DATE_FIELD_FAILURE),


    updateContrain: (noteId, epno, entity, entityKeyColumn, entityKeyValue, field, value) => (dispatch, getState) => {
        dispatch(noteActions.updateContrainRequest({ noteId, epno, entity, entityKeyColumn, entityKeyValue, field, value }));

        noteService.updateTextField(noteId, 'CPEPISODE', 'EPNO', epno, 'EPCONTRAIN', value)
            .then(() => {
                noteService.updateTextField(noteId, entity, entityKeyColumn, entityKeyValue, field, value)
                    .then(
                        () => {
                            dispatch(noteActions.updateContrainSuccess({ noteId, epno, entity, entityKeyColumn, entityKeyValue, field, value }));
                        }
                        ,
                        error => {
                            dispatch(noteActions.updateContrainFailure({ noteId, epno, entity, entityKeyColumn, entityKeyValue, field, value, error }));
                            dispatch(alertActions.error(Errors.NOTE_UPDATE_CONTRAIN_FAILURE));
                        }
                    );
            });
    },
    updateContrainRequest: createAction(ActionNames.NOTE_UPDATE_CONTRAIN_REQUEST),
    updateContrainSuccess: createAction(ActionNames.NOTE_UPDATE_CONTRAIN_SUCCESS),
    updateContrainFailure: createAction(ActionNames.NOTE_UPDATE_CONTRAIN_FAILURE),

    addTemplate: (noteId, teno) => dispatch => {
        dispatch(noteActions.addTemplateRequest({ noteId, teno }));

        noteService.addTemplate(noteId, teno)
            .then(
                response => {
                    dispatch(noteActions.addTemplateSuccess({ noteId, teno, obno: response.obno }));
                }
                ,
                error => {
                    dispatch(noteActions.addTemplateFailure({ noteId, teno }));
                    dispatch(alertActions.error(Errors.NOTE_ADD_TEMPLATE_FAILURE));
                }
            );
    },
    addTemplateRequest: createAction(ActionNames.NOTE_ADD_TEMPLATE_REQUEST),
    addTemplateSuccess: createAction(ActionNames.NOTE_ADD_TEMPLATE_SUCCESS),
    addTemplateFailure: createAction(ActionNames.NOTE_ADD_TEMPLATE_FAILURE),

    removeTemplate: (noteId, teno) => dispatch => {
        dispatch(noteActions.removeTemplateRequest({ noteId, teno }));

        noteService.removeTemplate(noteId, teno)
            .then(
                () => {
                    dispatch(noteActions.removeTemplateSuccess({ noteId, teno }));
                }
                ,
                error => {
                    dispatch(noteActions.removeTemplateFailure({ noteId, teno }));
                    dispatch(alertActions.error(Errors.NOTE_REMOVE_TEMPLATE_FAILURE));
                }
            );
    },
    removeTemplateRequest: createAction(ActionNames.NOTE_REMOVE_TEMPLATE_REQUEST),
    removeTemplateSuccess: createAction(ActionNames.NOTE_REMOVE_TEMPLATE_SUCCESS),
    removeTemplateFailure: createAction(ActionNames.NOTE_REMOVE_TEMPLATE_FAILURE),


    addChildRow: (noteId, table, tablePrefix, parentKeyColumn, parentKeyValue) => dispatch => {
        dispatch(noteActions.addChildRowRequest({ noteId, table, tablePrefix, parentKeyColumn, parentKeyValue }));

        noteService.addChildRow(noteId, table, tablePrefix, parentKeyColumn, parentKeyValue)
            .then(
                response => {
                    dispatch(noteActions.addChildRowSuccess({ noteId, table, tablePrefix, parentKeyColumn, parentKeyValue, response }));
                }
                ,
                error => {
                    dispatch(noteActions.addChildRowFailure({ noteId, table, tablePrefix, parentKeyColumn, parentKeyValue }));
                    dispatch(alertActions.error(Errors.NOTE_ADD_CHILD_ROW_FAILURE));
                }
            );
    },
    addChildRowRequest: createAction(ActionNames.NOTE_ADD_CHILD_ROW_REQUEST),
    addChildRowSuccess: createAction(ActionNames.NOTE_ADD_CHILD_ROW_SUCCESS),
    addChildRowFailure: createAction(ActionNames.NOTE_ADD_CHILD_ROW_FAILURE),

    applyGoalTemplateDetails: (noteId, goalArray) => (dispatch, getState) => {
        dispatch(noteActions.getAlTemplateRequest({ noteId, goalArray }));

        noteService.addGoalTemplates(noteId, goalArray)
            .then(
                response => {
                    dispatch(noteActions.addGoalDetailTemplateSuccess({ noteId, goalArray, response }));
                },
                error => {
                    dispatch(noteActions.addGoalDetailTemplateFailure({ noteId, goalArray, error }));
                    dispatch(alertActions.error(Errors.NOTE_ADD_GOAL_TEMPLATES));
                }
            )


    },
    addGoalDetailTemplateRequest: createAction(ActionNames.ADD_GOAL_DETAILS_REQUEST),
    addGoalDetailTemplateSuccess: createAction(ActionNames.ADD_GOAL_DETAILS_SUCCESS),
    addGoalDetailTemplateFailure: createAction(ActionNames.ADD_GOAL_DETAILS_FAILURE),

    toggleGoalTemplateDetails: (noteId) => (dispatch, getState) => {
        dispatch(noteActions.goalTemplateDetailsVisible({ noteId }))

    },

    goalTemplateDetailsVisible: createAction(ActionNames.GOAL_TEMPLATE_VISIBLE),

    addCustomGoal: (noteId, isWc = false, goalDate = undefined) => dispatch => {
        dispatch(noteActions.addCustomGoalRequest({ noteId, isWc, goalDate }));

        noteService.addCustomGoal(noteId, isWc, goalDate)
            .then(
                response => {
                    dispatch(noteActions.addCustomGoalSuccess({ noteId, isWc, goalDate, response }));
                }
                ,
                error => {
                    dispatch(noteActions.addCustomGoalFailure({ noteId, isWc, goalDate }));
                    dispatch(alertActions.error(Errors.NOTE_ADD_CUSTOM_GOAL_FAILURE));
                }
            );
    },
    addCustomGoalRequest: createAction(ActionNames.NOTE_ADD_CUSTOM_GOAL_REQUEST),
    addCustomGoalSuccess: createAction(ActionNames.NOTE_ADD_CUSTOM_GOAL_SUCCESS),
    addCustomGoalFailure: createAction(ActionNames.NOTE_ADD_CUSTOM_GOAL_FAILURE),

    addIndHepGoal: (noteId) => dispatch => {
        dispatch(noteActions.addIndHepGoalRequest({ noteId }));

        noteService.addIndHepGoal(noteId)
            .then(
                response => {
                    dispatch(noteActions.addIndHepGoalSuccess({ noteId, response }));
                }
                ,
                error => {
                    dispatch(noteActions.addIndHepGoalFailure({ noteId }));
                    dispatch(alertActions.error(Errors.NOTE_ADD_IND_HEP_GOAL_FAILURE));
                }
            );
    },
    addIndHepGoalRequest: createAction(ActionNames.NOTE_ADD_IND_HEP_GOAL_REQUEST),
    addIndHepGoalSuccess: createAction(ActionNames.NOTE_ADD_IND_HEP_GOAL_SUCCESS),
    addIndHepGoalFailure: createAction(ActionNames.NOTE_ADD_IND_HEP_GOAL_FAILURE),

    addChildRowGenerator: (noteId, table, tablePrefix, tableKeyColumn, parentKeyColumn, parentKeyValue, generatorTableName) => dispatch => {
        dispatch(noteActions.addChildRowGeneratorRequest({ noteId, table, tablePrefix, tableKeyColumn, parentKeyColumn, parentKeyValue, generatorTableName }));

        noteService.addChildRowGenerator(noteId, table, tablePrefix, tableKeyColumn, parentKeyColumn, parentKeyValue, generatorTableName)
            .then(
                response => {
                    dispatch(noteActions.addChildRowGeneratorSuccess({ noteId, table, tablePrefix, tableKeyColumn, parentKeyColumn, parentKeyValue, generatorTableName, response }));
                }
                ,
                error => {
                    dispatch(noteActions.addChildRowGeneratorFailure({ noteId, table, tablePrefix, tableKeyColumn, parentKeyColumn, parentKeyValue, generatorTableName }));
                    dispatch(alertActions.error(Errors.NOTE_ADD_CHILD_ROW_GENERATOR_FAILURE));
                }
            );
    },
    addChildRowGeneratorRequest: createAction(ActionNames.NOTE_ADD_CHILD_ROW_GENERATOR_REQUEST),
    addChildRowGeneratorSuccess: createAction(ActionNames.NOTE_ADD_CHILD_ROW_GENERATOR_SUCCESS),
    addChildRowGeneratorFailure: createAction(ActionNames.NOTE_ADD_CHILD_ROW_GENERATOR_FAILURE),

    addAlRow: (noteId, table, tablePrefix, tableKeyColumn, parentKeyColumn, parentKeyValue, generatorTableName, markAssistant = false, isSpeech = false) => dispatch => {
        dispatch(noteActions.addAlRowRequest({ noteId, table, tablePrefix, tableKeyColumn, parentKeyColumn, parentKeyValue, generatorTableName, markAssistant, isSpeech }));

        noteService.addAlRow(noteId, table, tablePrefix, tableKeyColumn, parentKeyColumn, parentKeyValue, generatorTableName, markAssistant, isSpeech)
            .then(
                response => {
                    dispatch(noteActions.addAlRowSuccess({ noteId, table, tablePrefix, tableKeyColumn, parentKeyColumn, parentKeyValue, generatorTableName, markAssistant, response }));
                }
                ,
                error => {
                    dispatch(noteActions.addAlRowFailure({ noteId, table, tablePrefix, tableKeyColumn, parentKeyColumn, parentKeyValue, generatorTableName, markAssistant }));
                    dispatch(alertActions.error(Errors.NOTE_ADD_AL_ROW_FAILURE));
                }
            );
    },
    addAlRowRequest: createAction(ActionNames.NOTE_ADD_AL_ROW_REQUEST),
    addAlRowSuccess: createAction(ActionNames.NOTE_ADD_AL_ROW_SUCCESS),
    addAlRowFailure: createAction(ActionNames.NOTE_ADD_AL_ROW_FAILURE),

    removeChildRow: (noteId, table, tablePrefix, pk) => dispatch => {
        dispatch(noteActions.removeChildRowRequest({ noteId, table, tablePrefix, pk }));

        noteService.removeChildRow(noteId, table, tablePrefix, pk)
            .then(
                response => {
                    dispatch(noteActions.removeChildRowSuccess({ noteId, table, tablePrefix, pk }));
                }
                ,
                error => {
                    dispatch(noteActions.removeChildRowFailure({ noteId, table, tablePrefix, pk }));
                    dispatch(alertActions.error(Errors.NOTE_REMOVE_CHILD_ROW_FAILURE));
                }
            );
    },
    removeChildRowRequest: createAction(ActionNames.NOTE_REMOVE_CHILD_ROW_REQUEST),
    removeChildRowSuccess: createAction(ActionNames.NOTE_REMOVE_CHILD_ROW_SUCCESS),
    removeChildRowFailure: createAction(ActionNames.NOTE_REMOVE_CHILD_ROW_FAILURE),


    updateAlModField: (noteId, entity, entityKeyColumn, entityKeyValue, field, value, timed) => (dispatch, getState) => {
        dispatch(noteActions.updateAlModFieldRequest({ noteId, entity, entityKeyColumn, entityKeyValue, field, value, timed }));

        noteService.updateAlModField(noteId, entity, entityKeyColumn, entityKeyValue, field, value, timed)
            .then(
                response => {
                    dispatch(noteActions.updateAlModFieldSuccess({ noteId, entity, entityKeyColumn, entityKeyValue, field, value, timed, response }));
                }
                ,
                error => {
                    dispatch(noteActions.updateAlModFieldFailure({ noteId, entity, entityKeyColumn, entityKeyValue, field, value, timed, error }));
                    dispatch(alertActions.error(Errors.NOTE_UPDATE_AL_MOD_FIELD_FAILURE));
                }
            );
    },
    updateAlModFieldRequest: createAction(ActionNames.NOTE_UPDATE_AL_MOD_FIELD_REQUEST),
    updateAlModFieldSuccess: createAction(ActionNames.NOTE_UPDATE_AL_MOD_FIELD_SUCCESS),
    updateAlModFieldFailure: createAction(ActionNames.NOTE_UPDATE_AL_MOD_FIELD_FAILURE),

    updateAlOtherField: (noteId, entity, entityKeyColumn, entityKeyValue, field, value) => (dispatch, getState) => {
        dispatch(noteActions.updateAlOtherFieldRequest({ noteId, entity, entityKeyColumn, entityKeyValue, field, value }));

        noteService.updateAlOtherField(noteId, entity, entityKeyColumn, entityKeyValue, field, value)
            .then(
                response => {
                    dispatch(noteActions.updateAlOtherFieldSuccess({ noteId, entity, entityKeyColumn, entityKeyValue, field, value, response }));
                }
                ,
                error => {
                    dispatch(noteActions.updateAlOtherFieldFailure({ noteId, entity, entityKeyColumn, entityKeyValue, field, value, error }));
                    dispatch(alertActions.error(Errors.NOTE_UPDATE_AL_OTHER_FIELD_FAILURE));
                }
            );
    },
    updateAlOtherFieldRequest: createAction(ActionNames.NOTE_UPDATE_AL_OTHER_FIELD_REQUEST),
    updateAlOtherFieldSuccess: createAction(ActionNames.NOTE_UPDATE_AL_OTHER_FIELD_SUCCESS),
    updateAlOtherFieldFailure: createAction(ActionNames.NOTE_UPDATE_AL_OTHER_FIELD_FAILURE),

    clearAl: (noteId) => (dispatch, getState) => {
        dispatch(noteActions.clearAlRequest({ noteId }));

        noteService.clearAl(noteId)
            .then(
                response => {
                    dispatch(noteActions.clearAlSuccess({ noteId, response }));
                }
                ,
                error => {
                    dispatch(noteActions.clearAlFailure({ noteId, error }));
                    dispatch(alertActions.error(Errors.NOTE_CLEAR_AL_FAILURE));
                }
            );
    },
    clearAlRequest: createAction(ActionNames.NOTE_CLEAR_AL_REQUEST),
    clearAlSuccess: createAction(ActionNames.NOTE_CLEAR_AL_SUCCESS),
    clearAlFailure: createAction(ActionNames.NOTE_CLEAR_AL_FAILURE),

    getNoteWarnings: (epno, noteId, date) => (dispatch) => {
        dispatch(noteActions.getNoteWarningRequest({ epno, noteId, date }));

        noteService.getNoteWarnings(epno, noteId, date)
            .then(
                response => {
                    dispatch(noteActions.getNoteWarningSuccess({ response, epno, noteId, date }));
                },
                error => {
                    dispatch(noteActions.getNoteWarningFailure({ epno, noteId, date }));
                    dispatch(alertActions.error(Errors.NOTE_GET_WARNING_FAILURE));
                }
            );
    },
    getNoteWarningRequest: createAction(ActionNames.NOTE_GET_WARNING_REQUEST),
    getNoteWarningSuccess: createAction(ActionNames.NOTE_GET_WARNING_SUCCESS),
    getNoteWarningFailure: createAction(ActionNames.NOTE_GET_WARNING_FAILURE),





    getAlTemplate: (tmpno, noteId, epno) => (dispatch, getState) => {
        dispatch(noteActions.getAlTemplateRequest({ tmpno, noteId, epno }));

        noteService.getAlTemplate(tmpno, noteId)
            .then(
                response => {
                    let isCustom = getState().entities.notes.MLTEMPLATE[tmpno + '_' + noteId].XLTMPURNO !== null ? true : false;
                    // process the response and determine which template entries should
                    // default to selected
                    if (response.entities.MLTMPAQUATICS && Object.keys(response.entities.MLTMPAQUATICS).length > 0) {
                        let valid = codeValidForAdmit(epno, '97113');
                        let keys = Object.keys(response.entities.MLTMPAQUATICS);
                        keys.forEach(x => {
                            response.entities.MLTMPAQUATICS[x].selected = valid && isCustom;
                            response.entities.MLTMPAQUATICS[x].valid = valid;
                        });
                    }
                    if (response.entities.MLTMPGAIT && Object.keys(response.entities.MLTMPGAIT).length > 0) {
                        let valid = codeValidForAdmit(epno, '97116');
                        let keys = Object.keys(response.entities.MLTMPGAIT);
                        keys.forEach(x => {
                            response.entities.MLTMPGAIT[x].selected = valid && isCustom;
                            response.entities.MLTMPGAIT[x].valid = valid;
                        });
                    }
                    if (response.entities.MLTMPMANUAL && Object.keys(response.entities.MLTMPMANUAL).length > 0) {
                        let valid = codeValidForAdmit(epno, '97140');
                        let keys = Object.keys(response.entities.MLTMPMANUAL);
                        keys.forEach(x => {
                            response.entities.MLTMPMANUAL[x].selected = valid && isCustom;
                            response.entities.MLTMPMANUAL[x].valid = valid;
                        });
                    }
                    if (response.entities.MLTMPMODALITIES && Object.keys(response.entities.MLTMPMODALITIES).length > 0) {
                        let keys = Object.keys(response.entities.MLTMPMODALITIES);
                        keys.forEach(x => {
                            let code = getState().entities.masterData.MLMASTERMODALITIES[response.entities.MLTMPMODALITIES[x].XLTMPMDMDNO].MDCODE;
                            let valid = codeValidForAdmit(epno, code);
                            response.entities.MLTMPMODALITIES[x].selected = valid && isCustom;
                            response.entities.MLTMPMODALITIES[x].valid = valid;
                        });
                    }
                    if (response.entities.MLTMPNEURO && Object.keys(response.entities.MLTMPNEURO).length > 0) {
                        let valid = codeValidForAdmit(epno, '97112');
                        let keys = Object.keys(response.entities.MLTMPNEURO);
                        keys.forEach(x => {
                            response.entities.MLTMPNEURO[x].selected = valid && isCustom;
                            response.entities.MLTMPNEURO[x].valid = valid;
                        });
                    }
                    if (response.entities.MLTMPOTHER && Object.keys(response.entities.MLTMPOTHER).length > 0) {
                        let keys = Object.keys(response.entities.MLTMPOTHER);
                        keys.forEach(x => {
                            let code = getState().entities.masterData.MLMASTEROTHER[response.entities.MLTMPOTHER[x].XLTMPOEOENO].OECODE;
                            let valid = codeValidForAdmit(epno, code);
                            response.entities.MLTMPOTHER[x].selected = valid && isCustom;
                            response.entities.MLTMPOTHER[x].valid = valid;
                        });
                    }
                    if (response.entities.MLTMPSELFCARE && Object.keys(response.entities.MLTMPSELFCARE).length > 0) {
                        let valid = codeValidForAdmit(epno, '97535');
                        let keys = Object.keys(response.entities.MLTMPSELFCARE);
                        keys.forEach(x => {
                            response.entities.MLTMPSELFCARE[x].selected = valid && isCustom;
                            response.entities.MLTMPSELFCARE[x].valid = valid;
                        });
                    }
                    if (response.entities.MLTMPSPECIALTYTESTS && Object.keys(response.entities.MLTMPSPECIALTYTESTS).length > 0) {
                        let keys = Object.keys(response.entities.MLTMPSPECIALTYTESTS);
                        keys.forEach(x => {
                            let code = getState().entities.masterData.MLMASTERSTANDARDIZEDTESTS[response.entities.MLTMPSPECIALTYTESTS[x].XLTMPSZSZNO].SZCODE;
                            let valid = codeValidForAdmit(epno, code);
                            response.entities.MLTMPSPECIALTYTESTS[x].selected = valid && isCustom;
                            response.entities.MLTMPSPECIALTYTESTS[x].valid = valid;
                        });
                    }
                    if (response.entities.MLTMPTHERACT && Object.keys(response.entities.MLTMPTHERACT).length > 0) {
                        let valid = codeValidForAdmit(epno, '97530');
                        let keys = Object.keys(response.entities.MLTMPTHERACT);
                        keys.forEach(x => {
                            response.entities.MLTMPTHERACT[x].selected = valid && isCustom;
                            response.entities.MLTMPTHERACT[x].valid = valid;
                        });
                    }
                    if (response.entities.MLTMPTHEREX && Object.keys(response.entities.MLTMPTHEREX).length > 0) {
                        let valid = codeValidForAdmit(epno, '97110');
                        let keys = Object.keys(response.entities.MLTMPTHEREX);
                        keys.forEach(x => {
                            response.entities.MLTMPTHEREX[x].selected = valid && isCustom;
                            response.entities.MLTMPTHEREX[x].valid = valid;
                        });
                    }

                    dispatch(noteActions.getAlTemplateSuccess({ tmpno, noteId, epno, isCustom, response }));
                }
                ,
                error => {
                    dispatch(noteActions.getAlTemplateFailure({ tmpno, noteId, epno, error }));
                    dispatch(alertActions.error(Errors.NOTE_GET_AL_TEMPLATE_FAILURE));
                }
            );
    },
    getAlTemplateRequest: createAction(ActionNames.NOTE_GET_AL_TEMPLATE_REQUEST),
    getAlTemplateSuccess: createAction(ActionNames.NOTE_GET_AL_TEMPLATE_SUCCESS),
    getAlTemplateFailure: createAction(ActionNames.NOTE_GET_AL_TEMPLATE_FAILURE),

    cancelAlTemplate: createAction(ActionNames.NOTE_CANCEL_AL_TEMPLATE),
    alTemplateToggleAllSelected: createAction(ActionNames.NOTE_AL_TEMPLATE_TOGGLE_ALL_SELECTED),
    alTemplateToggleItem: createAction(ActionNames.NOTE_AL_TEMPLATE_TOGGLE_ITEM),

    applyAlTemplate: (noteId) => (dispatch, getState) => {
        dispatch(noteActions.applyAlTemplateRequest({ noteId }));

        let noteType = parseInt(noteId.split("_")[0]);
        let pk = parseInt(noteId.split("_")[1]);
        let xlno = parseInt(Object.keys(getState().entities.notes.MLEXLOG)
            .find(key => (getState().entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
                || (getState().entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));

        let aqnos = getState().entities.notes.MLTMPAQUATICS ? Object.keys(getState().entities.notes.MLTMPAQUATICS)
            .filter(x => { return getState().entities.notes.MLTMPAQUATICS[x].selected === true })
            .map(x => getState().entities.notes.MLTMPAQUATICS[x].XLTMPAQNO) : [];

        let ganos = getState().entities.notes.MLTMPGAIT ? Object.keys(getState().entities.notes.MLTMPGAIT)
            .filter(x => { return getState().entities.notes.MLTMPGAIT[x].selected === true })
            .map(x => getState().entities.notes.MLTMPGAIT[x].XLTMPGANO) : [];

        let manos = getState().entities.notes.MLTMPMANUAL ? Object.keys(getState().entities.notes.MLTMPMANUAL)
            .filter(x => { return getState().entities.notes.MLTMPMANUAL[x].selected === true })
            .map(x => getState().entities.notes.MLTMPMANUAL[x].XLTMPMANO) : [];

        let mdnos = getState().entities.notes.MLTMPMODALITIES ? Object.keys(getState().entities.notes.MLTMPMODALITIES)
            .filter(x => { return getState().entities.notes.MLTMPMODALITIES[x].selected === true })
            .map(x => getState().entities.notes.MLTMPMODALITIES[x].XLTMPMDNO) : [];

        let nenos = getState().entities.notes.MLTMPNEURO ? Object.keys(getState().entities.notes.MLTMPNEURO)
            .filter(x => { return getState().entities.notes.MLTMPNEURO[x].selected === true })
            .map(x => getState().entities.notes.MLTMPNEURO[x].XLTMPNENO) : [];

        let oenos = getState().entities.notes.MLTMPOTHER ? Object.keys(getState().entities.notes.MLTMPOTHER)
            .filter(x => { return getState().entities.notes.MLTMPOTHER[x].selected === true })
            .map(x => getState().entities.notes.MLTMPOTHER[x].XLTMPOENO) : [];

        let scnos = getState().entities.notes.MLTMPSELFCARE ? Object.keys(getState().entities.notes.MLTMPSELFCARE)
            .filter(x => { return getState().entities.notes.MLTMPSELFCARE[x].selected === true })
            .map(x => getState().entities.notes.MLTMPSELFCARE[x].XLTMPSCNO) : [];

        let sznos = getState().entities.notes.MLTMPSPECIALTYTESTS ? Object.keys(getState().entities.notes.MLTMPSPECIALTYTESTS)
            .filter(x => { return getState().entities.notes.MLTMPSPECIALTYTESTS[x].selected === true })
            .map(x => getState().entities.notes.MLTMPSPECIALTYTESTS[x].XLTMPSZNO) : [];

        let tanos = getState().entities.notes.MLTMPTHERACT ? Object.keys(getState().entities.notes.MLTMPTHERACT)
            .filter(x => { return getState().entities.notes.MLTMPTHERACT[x].selected === true })
            .map(x => getState().entities.notes.MLTMPTHERACT[x].XLTMPTANO) : [];

        let tenos = getState().entities.notes.MLTMPTHEREX ? Object.keys(getState().entities.notes.MLTMPTHEREX)
            .filter(x => { return getState().entities.notes.MLTMPTHEREX[x].selected === true })
            .map(x => getState().entities.notes.MLTMPTHEREX[x].XLTMPTENO) : [];

        noteService.applyAlTemplate(xlno, noteId, aqnos, ganos, manos, mdnos, nenos, oenos, scnos, sznos, tanos, tenos)
            .then(
                response => {
                    dispatch(noteActions.applyAlTemplateSuccess({ noteId, response }));
                }
                ,
                error => {
                    dispatch(noteActions.applyAlTemplateFailure({ noteId, error }));
                    dispatch(alertActions.error(Errors.NOTE_APPLY_AL_TEMPLATE_FAILURE));
                }
            );
    },
    applyAlTemplateRequest: createAction(ActionNames.NOTE_APPLY_AL_TEMPLATE_REQUEST),
    applyAlTemplateSuccess: createAction(ActionNames.NOTE_APPLY_AL_TEMPLATE_SUCCESS),
    applyAlTemplateFailure: createAction(ActionNames.NOTE_APPLY_AL_TEMPLATE_FAILURE),

    saveAlTemplate: (noteId, xlno, name) => (dispatch) => {
        dispatch(noteActions.saveAlTemplateRequest({ noteId, xlno, name }));
        noteService.saveAlTemplate(xlno, name)
            .then(
                response => {
                    dispatch(noteActions.saveAlTemplateSuccess({ noteId, xlno, name, response }));
                    dispatch(alertActions.successMsg('Activity Log template successfully saved.'));
                }
                ,
                error => {
                    dispatch(noteActions.saveAlTemplateFailure({ noteId, xlno, name, error }));
                    dispatch(alertActions.error(Errors.NOTE_SAVE_AL_TEMPLATE_FAILURE));
                }
            );
    },
    saveAlTemplateRequest: createAction(ActionNames.NOTE_SAVE_AL_TEMPLATE_REQUEST),
    saveAlTemplateSuccess: createAction(ActionNames.NOTE_SAVE_AL_TEMPLATE_SUCCESS),
    saveAlTemplateFailure: createAction(ActionNames.NOTE_SAVE_AL_TEMPLATE_FAILURE),

    toggleSaveAlTemplateVisible: createAction(ActionNames.NOTE_TOGGLE_SAVE_AL_TEMPLATE_VISIBLE),

    deleteAlTemplate: (noteId, xltmpno) => (dispatch) => {
        dispatch(noteActions.deleteAlTemplateRequest({ noteId, xltmpno }));
        noteService.deleteAlTemplate(noteId, xltmpno)
            .then(
                response => {
                    dispatch(noteActions.deleteAlTemplateSuccess({ noteId, xltmpno, response }));
                    dispatch(alertActions.successMsg('Activity Log template successfully deleted.'));
                }
                ,
                error => {
                    dispatch(noteActions.deleteAlTemplateFailure({ noteId, xltmpno, error }));
                    dispatch(alertActions.error(Errors.NOTE_DELETE_AL_TEMPLATE_FAILURE));
                }
            );
    },
    deleteAlTemplateRequest: createAction(ActionNames.NOTE_DELETE_AL_TEMPLATE_REQUEST),
    deleteAlTemplateSuccess: createAction(ActionNames.NOTE_DELETE_AL_TEMPLATE_SUCCESS),
    deleteAlTemplateFailure: createAction(ActionNames.NOTE_DELETE_AL_TEMPLATE_FAILURE),


    undoDeleteAlTemplate: (noteId, xltmpno) => (dispatch) => {
        dispatch(noteActions.undoDeleteAlTemplateRequest({ noteId, xltmpno }));
        noteService.undoDeleteAlTemplate(noteId, xltmpno)
            .then(
                response => {
                    dispatch(noteActions.undoDeleteAlTemplateSuccess({ noteId, xltmpno, response }));
                    dispatch(alertActions.successMsg('Activity Log template successfully restored.'));
                }
                ,
                error => {
                    dispatch(noteActions.undoDeleteAlTemplateFailure({ noteId, xltmpno, error }));
                    dispatch(alertActions.error(Errors.NOTE_UNDO_DELETE_AL_TEMPLATE_FAILURE));
                }
            );
    },
    undoDeleteAlTemplateRequest: createAction(ActionNames.NOTE_UNDO_DELETE_AL_TEMPLATE_REQUEST),
    undoDeleteAlTemplateSuccess: createAction(ActionNames.NOTE_UNDO_DELETE_AL_TEMPLATE_SUCCESS),
    undoDeleteAlTemplateFailure: createAction(ActionNames.NOTE_UNDO_DELETE_AL_TEMPLATE_FAILURE),

    addGoal: (noteId, name = undefined, isFoto = undefined, goalDate = undefined) => (dispatch) => {
        dispatch(noteActions.addGoalRequest({ noteId, name, isFoto, goalDate }));
        noteService.addGoal(noteId, name, isFoto, goalDate)
            .then(
                response => {
                    dispatch(noteActions.addGoalSuccess({ noteId, name, isFoto, response, goalDate }));
                }
                ,
                error => {
                    dispatch(noteActions.addGoalFailure({ noteId, name, isFoto, goalDate, error }));
                    dispatch(alertActions.error(Errors.NOTE_ADD_GOAL_FAILURE));
                }
            );
    },
    addGoalRequest: createAction(ActionNames.NOTE_ADD_GOAL_REQUEST),
    addGoalSuccess: createAction(ActionNames.NOTE_ADD_GOAL_SUCCESS),
    addGoalFailure: createAction(ActionNames.NOTE_ADD_GOAL_FAILURE),

    updateDatesLTG: (noteId, goalDate) => (dispatch) => {
        dispatch(noteActions.updateDatesLTGRequest({ noteId, goalDate }));
        noteService.updateDatesLTG(noteId, goalDate)
            .then(
                response => {
                    dispatch(noteActions.updateDatesLTGSuccess({ noteId, goalDate, response }));
                }
                ,
                error => {
                    dispatch(noteActions.updateDatesLTGFailure({ noteId, goalDate, error }));
                    dispatch(alertActions.error(Errors.UPDATE_LTG_DATE_FAILURE));
                }
            );
    },
    updateDatesLTGRequest: createAction(ActionNames.UPDATE_LTG_DATE_REQUEST),
    updateDatesLTGSuccess: createAction(ActionNames.UPDATE_LTG_DATE_SUCCESS),
    updateDatesLTGFailure: createAction(ActionNames.UPDATE_LTG_DATE_FAILURE),

    updateDatesSTG: (noteId, goalDate) => (dispatch) => {
        dispatch(noteActions.updateDatesSTGRequest({ noteId, goalDate }));
        noteService.updateDatesSTG(noteId, goalDate)
            .then(
                response => {
                    dispatch(noteActions.updateDatesSTGSuccess({ noteId, goalDate, response }));
                }
                ,
                error => {
                    dispatch(noteActions.updateDatesSTGFailure({ noteId, goalDate, error }));
                    dispatch(alertActions.error(Errors.UPDATE_STG_DATE_FAILURE));
                }
            );
    },
    updateDatesSTGRequest: createAction(ActionNames.UPDATE_STG_DATE_REQUEST),
    updateDatesSTGSuccess: createAction(ActionNames.UPDATE_STG_DATE_SUCCESS),
    updateDatesSTGFailure: createAction(ActionNames.UPDATE_STG_DATE_FAILURE),


    addCustomSTGoal: (noteId, goalDate = undefined) => (dispatch) => {
        dispatch(noteActions.addSTGoalRequest({ noteId, goalDate }));
        noteService.addCustomSTGoal(noteId, goalDate)
            .then(
                response => {
                    dispatch(noteActions.addSTGoalSuccess({ noteId, goalDate, response }));
                }
                ,
                error => {
                    dispatch(noteActions.addSTGoalFailure({ noteId, goalDate, error }));
                    dispatch(alertActions.error(Errors.NOTE_ADD_GOAL_FAILURE));
                }
            );
    },
    addSTGoalRequest: createAction(ActionNames.NOTE_ADD_STGOAL_REQUEST),
    addSTGoalSuccess: createAction(ActionNames.NOTE_ADD_STGOAL_SUCCESS),
    addSTGoalFailure: createAction(ActionNames.NOTE_ADD_STGOAL_FAILURE),

    setStgDateDefault: createAction(ActionNames.NOTE_SET_STGDATEDEFAULT),

    selectGoal: createAction(ActionNames.NOTE_SELECT_GOAL),
    // deleteGoal: (noteId, gono) => (dispatch) => {
    //     dispatch(noteActions.deleteGoalRequest({ noteId, gono }));
    //     noteService.deleteGoal(noteId, gono)
    //         .then(
    //             response => {
    //                 dispatch(noteActions.deleteGoalSuccess({ noteId, gono, response }));
    //             }
    //             ,
    //             error => {
    //                 dispatch(noteActions.deleteGoalFailure({ noteId, gono, error }));
    //                 dispatch(alertActions.error(Errors.NOTE_DELETE_GOAL_FAILURE));
    //             }
    //         );
    // },
    // deleteGoalRequest: createAction(ActionNames.NOTE_DELETE_GOAL_REQUEST),
    // deleteGoalSuccess: createAction(ActionNames.NOTE_DELETE_GOAL_SUCCESS),
    // deleteGoalFailure: createAction(ActionNames.NOTE_DELETE_GOAL_FAILURE),

    favoriteGoal: (noteId, gfname, gfmgno, gfcustom, gfgoallevel, gfobjective, gfworktask) => (dispatch) => {
        dispatch(noteActions.favoriteGoalRequest({ noteId, gfname, gfmgno, gfcustom, gfgoallevel, gfobjective, gfworktask }));
        noteService.favoriteGoal(noteId, gfname, gfmgno, gfcustom, gfgoallevel, gfobjective, gfworktask)
            .then(
                response => {
                    dispatch(noteActions.favoriteGoalSuccess({ noteId, gfname, gfmgno, gfcustom, gfgoallevel, gfobjective, gfworktask, response }));
                    dispatch(alertActions.successMsg('Goal favorite successfully saved.'));
                }
                ,
                error => {
                    dispatch(noteActions.favoriteGoalFailure({ noteId, gfname, gfmgno, gfcustom, gfgoallevel, gfobjective, gfworktask, error }));
                    dispatch(alertActions.error(Errors.NOTE_FAVORITE_GOAL_FAILURE));
                }
            );
    },
    favoriteGoalRequest: createAction(ActionNames.NOTE_FAVORITE_GOAL_REQUEST),
    favoriteGoalSuccess: createAction(ActionNames.NOTE_FAVORITE_GOAL_SUCCESS),
    favoriteGoalFailure: createAction(ActionNames.NOTE_FAVORITE_GOAL_FAILURE),

    toggleFavoriteGoalVisible: createAction(ActionNames.NOTE_TOGGLE_FAVORITE_GOAL_VISIBLE),

    applyFavoriteGoal: (noteId, gono, gfno) => (dispatch) => {
        dispatch(noteActions.applyFavoriteGoalRequest({ noteId, gono, gfno }));
        noteService.applyFavoriteGoal(noteId, gono, gfno)
            .then(
                response => {
                    dispatch(noteActions.applyFavoriteGoalSuccess({ noteId, gono, gfno, response }));
                }
                ,
                error => {
                    dispatch(noteActions.applyFavoriteGoalFailure({ noteId, gono, gfno, error }));
                    dispatch(alertActions.error(Errors.NOTE_APPLY_FAVORITE_GOAL_FAILURE));
                }
            );
    },
    applyFavoriteGoalRequest: createAction(ActionNames.NOTE_APPLY_FAVORITE_GOAL_REQUEST),
    applyFavoriteGoalSuccess: createAction(ActionNames.NOTE_APPLY_FAVORITE_GOAL_SUCCESS),
    applyFavoriteGoalFailure: createAction(ActionNames.NOTE_APPLY_FAVORITE_GOAL_FAILURE),

    clearGoals: (noteId, reason) => (dispatch) => {
        dispatch(noteActions.clearGoalsRequest({ noteId, reason }));
        noteService.clearGoals(noteId, reason)
            .then(
                response => {
                    dispatch(noteActions.clearGoalsSuccess({ noteId, reason, response }));
                }
                ,
                error => {
                    dispatch(noteActions.clearGoalsFailure({ noteId, reason, error }));
                    dispatch(alertActions.error(Errors.NOTE_CLEAR_GOALS_FAILURE));
                }
            );
    },
    clearGoalsRequest: createAction(ActionNames.NOTE_CLEAR_GOALS_REQUEST),
    clearGoalsSuccess: createAction(ActionNames.NOTE_CLEAR_GOALS_SUCCESS),
    clearGoalsFailure: createAction(ActionNames.NOTE_CLEAR_GOALS_FAILURE),

    addSTGFlag: (noteId, flagText, custom, stgDateDefault) => (dispatch) => {
        dispatch(noteActions.addSTGFlagRequest({ noteId, flagText, stgDateDefault }));
        noteService.addSTGFlag(noteId, flagText, custom, stgDateDefault)
            .then(
                response => {
                    dispatch(noteActions.addSTGFlagSuccess({ noteId, flagText, response, stgDateDefault }));
                }
                ,
                error => {
                    dispatch(noteActions.addSTGFlagFailure({ noteId, flagText, stgDateDefault, error }));
                    dispatch(alertActions.error(Errors.NOTE_ADD_ASSESSMENT_FLAG_FAILURE));
                }
            );
    },
    addSTGFlagRequest: createAction(ActionNames.NOTE_ADD_STG_FLAG_REQUEST),
    addSTGFlagSuccess: createAction(ActionNames.NOTE_ADD_STG_FLAG_SUCCESS),
    addSTGFlagFailure: createAction(ActionNames.NOTE_ADD_STG_FLAG_FAILURE),


    addAssessmentFlag: (noteId, asno, mopno, flagText) => (dispatch) => {
        dispatch(noteActions.addAssessmentFlagRequest({ noteId, asno, mopno, flagText }));
        noteService.addAssessmentFlag(noteId, asno, mopno, flagText)
            .then(
                response => {
                    dispatch(noteActions.addAssessmentFlagSuccess({ noteId, asno, mopno, flagText, response }));
                    dispatch(alertActions.successMsg('Successfully added item to Goals.'));
                }
                ,
                error => {
                    dispatch(noteActions.addAssessmentFlagFailure({ noteId, asno, mopno, flagText, error }));
                    dispatch(alertActions.error(Errors.NOTE_ADD_ASSESSMENT_FLAG_FAILURE));
                }
            );
    },
    addAssessmentFlagRequest: createAction(ActionNames.NOTE_ADD_ASSESSMENT_FLAG_REQUEST),
    addAssessmentFlagSuccess: createAction(ActionNames.NOTE_ADD_ASSESSMENT_FLAG_SUCCESS),
    addAssessmentFlagFailure: createAction(ActionNames.NOTE_ADD_ASSESSMENT_FLAG_FAILURE),

    addPlanSubCat: (noteId, plno, mdno, timed, oeno) => (dispatch) => {
        dispatch(noteActions.addPlanSubCatRequest({ noteId, plno, mdno, timed, oeno }));
        noteService.addPlanSubCat(noteId, plno, mdno, timed, oeno)
            .then(
                response => {
                    dispatch(noteActions.addPlanSubCatSuccess({ noteId, plno, mdno, timed, oeno, response }));
                }
                ,
                error => {
                    dispatch(noteActions.addPlanSubCatFailure({ noteId, plno, mdno, timed, oeno, error }));
                    dispatch(alertActions.error(Errors.NOTE_ADD_PLAN_SUB_CAT_FAILURE));
                }
            );
    },
    addPlanSubCatRequest: createAction(ActionNames.NOTE_ADD_PLAN_SUB_CAT_REQUEST),
    addPlanSubCatSuccess: createAction(ActionNames.NOTE_ADD_PLAN_SUB_CAT_SUCCESS),
    addPlanSubCatFailure: createAction(ActionNames.NOTE_ADD_PLAN_SUB_CAT_FAILURE),

    updateAllAssessmentFlags: (noteId, asno, val, type) => (dispatch) => {
        dispatch(noteActions.updateAllAssessmentFlagsRequest({ noteId, asno, val, type }));
        noteService.updateAllAssessmentFlags(noteId, asno, val, type)
            .then(
                response => {
                    dispatch(noteActions.updateAllAssessmentFlagsSuccess({ noteId, asno, val, response }));
                }
                ,
                error => {
                    dispatch(noteActions.updateAllAssessmentFlagsFailure({ noteId, asno, val, error }));
                    dispatch(alertActions.error(Errors.NOTE_UPDATE_ALL_ASSESSMENT_FLAGS_FAILURE));
                }
            );
    },
    updateAllAssessmentFlagsRequest: createAction(ActionNames.NOTE_UPDATE_ALL_ASSESSMENT_FLAGS_REQUEST),
    updateAllAssessmentFlagsSuccess: createAction(ActionNames.NOTE_UPDATE_ALL_ASSESSMENT_FLAGS_SUCCESS),
    updateAllAssessmentFlagsFailure: createAction(ActionNames.NOTE_UPDATE_ALL_ASSESSMENT_FLAGS_FAILURE),

    updateAllShortGoalFlags: (noteId, asno, val, type) => (dispatch) => {
        dispatch(noteActions.updateAllShortGoalFlagsRequest({ noteId, asno, val, type }));
        noteService.updateAllShortGoalFlags(noteId, asno, val, type)
            .then(
                response => {
                    dispatch(noteActions.updateAllShortGoalFlagsSuccess({ noteId, asno, val, response }));
                }
                ,
                error => {
                    dispatch(noteActions.updateAllShortGoalFlagsFailure({ noteId, asno, val, error }));
                    dispatch(alertActions.error(Errors.NOTE_UPDATE_ALL_GOAL_FLAGS_FAILURE));
                }
            );
    },
    updateAllShortGoalFlagsRequest: createAction(ActionNames.NOTE_UPDATE_ALL_SHORT_GOAL_FLAGS_REQUEST),
    updateAllShortGoalFlagsSuccess: createAction(ActionNames.NOTE_UPDATE_ALL_SHORT_GOAL_FLAGS_SUCCESS),
    updateAllShortGoalFlagsFailure: createAction(ActionNames.NOTE_UPDATE_ALL_SHORT_GOAL_FLAGS_FAILURE),

    updateAllGoalFlags: (noteId, asno, val, type) => (dispatch) => {
        dispatch(noteActions.updateAllGoalFlagsRequest({ noteId, asno, val, type }));
        noteService.updateAllGoalFlags(noteId, asno, val, type)
            .then(
                response => {
                    dispatch(noteActions.updateAllGoalFlagsSuccess({ noteId, asno, val, response }));
                }
                ,
                error => {
                    dispatch(noteActions.updateAllGoalFlagsFailure({ noteId, asno, val, error }));
                    dispatch(alertActions.error(Errors.NOTE_UPDATE_ALL_SHORT_GOAL_FLAGS_FAILURE));
                }
            );
    },
    updateAllGoalFlagsRequest: createAction(ActionNames.NOTE_UPDATE_ALL_GOAL_FLAGS_REQUEST),
    updateAllGoalFlagsSuccess: createAction(ActionNames.NOTE_UPDATE_ALL_GOAL_FLAGS_SUCCESS),
    updateAllGoalFlagsFailure: createAction(ActionNames.NOTE_UPDATE_ALL_GOAL_FLAGS_FAILURE),



    toggleValidationVisibility: createAction(ActionNames.NOTE_TOGGLE_VALIDATION_VISIBILITY),


    clearAlGroup: (noteId) => (dispatch, getState) => {
        dispatch(noteActions.clearAlGroupRequest({ noteId }));

        noteService.clearAlGroup(noteId)
            .then(
                response => {
                    dispatch(noteActions.clearAlGroupSuccess({ noteId, response }));
                }
                ,
                error => {
                    dispatch(noteActions.clearAlGroupFailure({ noteId, error }));
                    dispatch(alertActions.error(Errors.NOTE_CLEAR_AL_GROUP_FAILURE));
                }
            );
    },
    clearAlGroupRequest: createAction(ActionNames.NOTE_CLEAR_AL_GROUP_REQUEST),
    clearAlGroupSuccess: createAction(ActionNames.NOTE_CLEAR_AL_GROUP_SUCCESS),
    clearAlGroupFailure: createAction(ActionNames.NOTE_CLEAR_AL_GROUP_FAILURE),

    computeCharges: (noteId) => (dispatch, getState) => {
        dispatch(noteActions.computeChargesRequest({ noteId }));

        noteService.computeCharges(noteId)
            .then(
                response => {
                    dispatch(noteActions.computeChargesSuccess({ noteId, response }));
                }
                ,
                error => {
                    dispatch(noteActions.computeChargesFailure({ noteId, error }));
                    dispatch(alertActions.error(Errors.NOTE_COMPUTE_CHARGES_FAILURE));
                }
            );
    },
    computeChargesRequest: createAction(ActionNames.NOTE_COMPUTE_CHARGES_REQUEST),
    computeChargesSuccess: createAction(ActionNames.NOTE_COMPUTE_CHARGES_SUCCESS),
    computeChargesFailure: createAction(ActionNames.NOTE_COMPUTE_CHARGES_FAILURE),

    hideComputedCharges: createAction(ActionNames.HIDE_COMPUTED_CHARGES),

    saveFinal: (noteId, epno, checkDate, trtdate) => (dispatch, getState) => {
        let ptno = getState().entities.cdv[noteId].ptno;
        let type = parseInt(noteId.split("_")[0]);

        dispatch(noteActions.saveFinalRequest({ noteId }));
        let datewarning = false;
        let isChargeExist = false;
        if (checkDate) {
            noteService.checkDate(noteId, epno, trtdate)
                .then(
                    response => {
                        switch (response.result) {
                            case 0: //warn
                                //inform user no apt for the selected trt date
                                dispatch(noteActions.warnAptDate({ noteId }));
                                datewarning = true;
                                break;
                            case 1: // success
                                // date valid, do nothing
                                break;
                            case 2: // charge already exist
                                isChargeExist = true;
                                dispatch(noteActions.isChargeExist({ noteId }));
                                break;
                            default:
                                break;
                        }
                        if (!datewarning && !isChargeExist) {
                            noteService.saveFinal(noteId, epno)
                                .then(
                                    response => {
                                        dispatch(patientActions.close(ptno));
                                        dispatch(noteActions.saveFinalSuccess({ noteId, ptno, response }));
                                        dispatch(dashboardActions.loadOutstandingNotesQuiet());
                                        dispatch(notesPendingActionActions.load());
                                        if (type === 4 || type === 6 || type === 3 || type === 5) {
                                            dispatch(dcDueActions.load());
                                            if (epno === getState().ui.dcDue.selectedMessage) {
                                                dispatch(dcDueActions.clearSelection());
                                            }
                                        }
                                        if (type === 3 || type === 5) {
                                            dispatch(pnDueActions.load());
                                            if (epno === getState().ui.pnDue.selectedMessage) {
                                                dispatch(pnDueActions.clearSelection());
                                            }
                                        }
                                        dispatch(alertActions.successMsg('Note Successfully Finalized.'));
                                    }
                                    ,
                                    error => {
                                        error = true;
                                        dispatch(noteActions.saveFinalFailure({ noteId, error }));
                                        dispatch(alertActions.error(Errors.NOTE_SAVE_FINAL_FAILURE));
                                    }
                                );
                        }
                    },
                    error => {
                        error = true;
                        dispatch(noteActions.warnAptDate({ noteId, error }));
                        dispatch(alertActions.error(Errors.NOTE_SAVE_FINAL_FAILURE));
                    });

        }

        if (!checkDate) {
            noteService.saveFinal(noteId, epno)
                .then(
                    response => {
                        dispatch(patientActions.close(ptno));
                        dispatch(noteActions.saveFinalSuccess({ noteId, ptno, response }));
                        dispatch(dashboardActions.loadOutstandingNotesQuiet());
                        dispatch(notesPendingActionActions.load());
                        if (type === 4 || type === 6 || type === 3 || type === 5) {
                            dispatch(dcDueActions.load());
                            if (epno === getState().ui.dcDue.selectedMessage) {
                                dispatch(dcDueActions.clearSelection());
                            }
                        }
                        if (type === 3 || type === 5) {
                            dispatch(pnDueActions.load());
                            if (epno === getState().ui.pnDue.selectedMessage) {
                                dispatch(pnDueActions.clearSelection());
                            }
                        }
                        dispatch(alertActions.successMsg('Note Successfully Finalized.'));
                    }
                    ,
                    error => {
                        error = true;
                        dispatch(noteActions.saveFinalFailure({ noteId, error }));
                        dispatch(alertActions.error(Errors.NOTE_SAVE_FINAL_FAILURE));
                    }
                );
        }
    },
    saveFinalRequest: createAction(ActionNames.NOTE_SAVE_FINAL_REQUEST),
    saveFinalSuccess: createAction(ActionNames.NOTE_SAVE_FINAL_SUCCESS),
    warnAptDate: createAction(ActionNames.WARN_APT_DATE),
    isChargeExist: createAction(ActionNames.IS_CHARGE_EXIST),
    clearAptDate: createAction(ActionNames.CLEAR_APT_DATE),
    saveFinalFailure: createAction(ActionNames.NOTE_SAVE_FINAL_FAILURE),

    convert: (noteId, noteType) => (dispatch, getState) => {
        let ptno = getState().entities.cdv[noteId].ptno;
        let epno = getState().entities.cdv[noteId].epno;
        dispatch(noteActions.convertRequest({ noteId }));
        let pk = parseInt(noteId.split("_")[1]);

        noteService.convert(noteId, noteType)
            .then(
                response => {
                    dispatch(noteActions.convertSuccess({ noteId, pk, noteType, response }));
                    dispatch(cdvActions.refreshCdv(ptno));
                    dispatch(patientActions.closeTab({ tabId: 'IN_' + noteId, ptno, noteId }));
                    dispatch(noteActions.openInProgNote(noteType + '_' + pk, ptno, epno));
                    dispatch(dashboardActions.loadOutstandingNotesQuiet());
                    dispatch(alertActions.successMsg('Note Successfully Converted.'));
                }
                ,
                error => {
                    dispatch(noteActions.convertFailure({ noteId, noteType, error }));
                    dispatch(alertActions.error(Errors.NOTE_CONVERT_FAILURE));
                }
            );

    },
    convertRequest: createAction(ActionNames.NOTE_CONVERT_REQUEST),
    convertSuccess: createAction(ActionNames.NOTE_CONVERT_SUCCESS),
    convertFailure: createAction(ActionNames.NOTE_CONVERT_FAILURE),

    saveObjectiveTemplate: (noteId, name) => (dispatch) => {
        dispatch(noteActions.saveObjectiveTemplateRequest({ noteId, name }));
        noteService.saveObjectiveTemplate(noteId, name)
            .then(
                response => {
                    dispatch(noteActions.saveObjectiveTemplateSuccess({ noteId, name, response }));
                    dispatch(alertActions.successMsg('Objective template successfully saved.'));
                }
                ,
                error => {
                    dispatch(noteActions.saveObjectiveTemplateFailure({ noteId, name, error }));
                    dispatch(alertActions.error(Errors.NOTE_SAVE_OBJECTIVE_TEMPLATE_FAILURE));
                }
            );
    },
    saveObjectiveTemplateRequest: createAction(ActionNames.NOTE_SAVE_OBJECTIVE_TEMPLATE_REQUEST),
    saveObjectiveTemplateSuccess: createAction(ActionNames.NOTE_SAVE_OBJECTIVE_TEMPLATE_SUCCESS),
    saveObjectiveTemplateFailure: createAction(ActionNames.NOTE_SAVE_OBJECTIVE_TEMPLATE_FAILURE),



}
